import * as api from '../util/apis';
import { ENV } from '../constants/Constants';
import {
	getAdvertisementFromJson,
	getJsonFromAdvertisement,
} from '../jsonutils/advertisement';
import { Advertisement, AdvertisementAsset } from '@horasys/bellplus/common/types';

export type UPLOAD_ASSET_TYPE =
	| 'advertisement'
	| 'mainLocation'
	| 'locationGroup'
	| 'screenshots'
	| 'layout'
	| 'userProfile';

export const getAdvertisementData = async (
	pageIndex = 0,
	pageSize = 10,
	filterRequestObject: any = [],
	sortRequestObject: any = [],
): Promise<any> => {
	try {
		const filterArray = filterRequestObject.filter((filter: any) => {
			if (filter.value.length > 0) {
				return true;
			}
			return false;
		});
		const requestObject = {
			pageIndex: pageIndex,
			pageSize: pageSize,
			sort: sortRequestObject,
			filters: filterArray,
		};
		const resp: any = await api.postapiresponses(
			ENV.dev.advertisement + '/list',
			requestObject,
		);
		const advertisements: any = resp.data.data;
		return Promise.resolve(advertisements);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateAd = async (advertisementId: any, requestData: any) => {
	const request = getJsonFromAdvertisement(requestData);
	const resp = await api.putapiresponses(
		ENV.dev.advertisement + '/' + advertisementId,
		request,
	);
	return resp;
};

export const getTemplates = async () => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.template);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createAd = async (advertisement: Advertisement) => {
	try {
		const requestData = getJsonFromAdvertisement(advertisement);
		await api.postapiresponses(ENV.dev.advertisement, requestData);
		return Promise.resolve();
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCampaignAdvertisementDetails = async (
	pageIndex = 0,
	pageSize = 10,
	filterRequestObject: any = [],
	sortRequestObject: any = [],
): Promise<Array<Advertisement>> => {
	try {
		const filterArray = filterRequestObject.filter((filter: any) => {
			if (filter.value.length > 0) {
				return true;
			}
			return false;
		});
		const requestObject = {
			pageIndex: pageIndex,
			pageSize: pageSize,
			sort: sortRequestObject,
			filters: filterArray,
		};
		const resp: any = await api.postapiresponses(
			ENV.dev.advertisement + '/list',
			requestObject,
		);
		const advertisements: Array<Advertisement> = resp.data.data.list.map(
			(adJson: any) => {
				return getAdvertisementFromJson(adJson);
			},
		);
		return Promise.resolve(advertisements);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const advertisementDetailsbyId = async (
	adversementId: number,
): Promise<Advertisement> => {
	try {
		console.log(' am in axios service', adversementId);
		const resp: any = await api.getapiresponses(
			ENV.dev.advertisement + '/' + adversementId,
		);
		const advertisement: Advertisement = await getAdvertisementFromJson(
			resp.data.data,
		);
		return Promise.resolve(advertisement);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteAsset = async (id: number): Promise<any> => {
	let resp;
	try {
		resp = await api.deleteapiresponses(
			ENV.dev.uploadassets + '/' + id + '/type/advertisement',
		);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const advertisementDetailsbyClientId = async (
	clientId: any,
): Promise<Array<Advertisement>> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.client + '/' + clientId + '/advertisement',
		);
		const advertisements: Array<Advertisement> = [];
		resp.data.data.forEach((json: any) => {
			const ad: Advertisement = getAdvertisementFromJson(json);
			advertisements.push(ad);
		});
		return Promise.resolve(advertisements);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getPrimaryAssetType = (advertisement: Partial<Advertisement>): string => {
	let primaryAsset: AdvertisementAsset = {} as AdvertisementAsset;

	advertisement.templateAssets?.forEach((adAsset: AdvertisementAsset) => {
		if (adAsset.isPrimary) {
			primaryAsset = adAsset;
		}
	});
	if (primaryAsset.type === 'multipleImages') return 'image';
	return primaryAsset.type;
};

export const getPrimaryAsset = (
	advertisement: Partial<Advertisement>,
): AdvertisementAsset => {
	console.log(advertisement);
	let primaryAsset: AdvertisementAsset = {} as AdvertisementAsset;

	advertisement.templateAssets?.forEach((adAsset: AdvertisementAsset) => {
		if (adAsset.isPrimary) {
			primaryAsset = adAsset;
		}
	});

	return primaryAsset;
};
export const deleteAdvertisementDetailsById = async (
	advertisementId: number,
): Promise<any> => {
	try {
		const resp: any = await api.deleteapiresponses(
			ENV.dev.advertisement + '/' + advertisementId,
		);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const checkAdvertisementByName = async (enteredName: string): Promise<any> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.advertisement + '/searchByName/' + enteredName,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getRecentAdvertisements = (): any => {
	return async () => {
		try {
			const requestObject = {
				pageIndex: 0,
				pageSize: 10,
				sort: [],
				filters: [],
			};
			const resp: any = await api.postapiresponses(ENV.dev.advertisement + '/list', requestObject);
			return Promise.resolve(resp.data.data.list);
		} catch (error) {
			return Promise.reject(error);
		}
	}
};
